import {
  CreateNpsResponseDocument,
  CreateNpsResponseMutationVariables,
  UpdateNpsIntentDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useCreateNpsResponse = () => {
  const {
    company: { id: companyId },
    access: { id: authorId },
  } = useCurrentSession()
  const [createNpsResponse, { loading }] = useMutation(CreateNpsResponseDocument, {
    extractorFn: (data) => data.npsMutations.createNpsSurveyResponse,
  })
  const [updateNpsIntent, { loading: loadingUpdate }] = useMutation(UpdateNpsIntentDocument, {
    extractorFn: (data) => data.npsMutations.updateNpsSurveyResponseIntent,
  })

  return {
    loading: loading || loadingUpdate,
    create: async (
      variables: Omit<CreateNpsResponseMutationVariables, 'authorId' | 'companyId'>,
      surveyIntentId?: string
    ) => {
      const result = await createNpsResponse({
        variables: { ...variables, companyId, authorId },
      })
      const handled = handleResult(result, () => undefined)

      if (surveyIntentId && handled.success) {
        await updateNpsIntent({
          variables: {
            id: surveyIntentId,
            surveyResponseId: String(handled.data.surveyResponse?.id),
          },
        })
      }

      return result
    },
  }
}
